// 路由配置对象数组
const routes = [
    {
        // 匹配不到任何路由时重定向到首页
        path: '*',
        redirect: 'index'
    },
    {
        name: 'index'
    },
    {
        name: 'grid',
        children: [
            {
                name: 'grid/event'
            },
            {
                name: 'grid/family'
            },
            {
                name: 'grid/party'
            },
            {
                name: 'grid/special'
            }
        ]
    },
    {
        name: "login"
    },
    {
        name: "party"
    }
];

// 递归函数，为每个路由对象添加路径、元数据和组件等属性
function initRoutes(routes) {
    if (routes) {
        routes.forEach(route => {
            if (route.name) {
                // 添加路径属性
                route.path = '/' + route.name;
                // 添加组件属性，并使用异步加载组件的方式
                route.component = () => import('../views/' + route.name);
                // 递归遍历子路由
                initRoutes(route.children);
            }
        });
    }
}

// 初始化所有路由对象
initRoutes(routes);

// 导出路由配置数组
export default routes;
